import { render } from "./PageViewDataDiskon.vue?vue&type=template&id=d3bab086"
import script from "./PageViewDataDiskon.vue?vue&type=script&lang=js"
export * from "./PageViewDataDiskon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__